(function () {
  'use strict';

  var MAX_THUMBS = 2;
  var bar = null;
  var thumbsContainer = null;
  var countEl = null;
  var totalEl = null;
  var isUpdating = false;
  var updateTimer = null;
  var lastCartToken = '';
  var originalFetch = window.fetch.bind(window);

  /* ══════════════════════════════════════
     BUILD THE FLOATING BAR HTML
     ══════════════════════════════════════ */
  function createBar() {
    bar = document.createElement('div');
    bar.className = 'floating-cart-bar';
    bar.id = 'floating-cart-bar';
    bar.innerHTML =
      '<div class="floating-cart-inner">' +
        '<div class="floating-cart-left">' +
          '<div class="floating-cart-thumbnails" id="floating-cart-thumbnails"></div>' +
          '<div class="floating-cart-info">' +
            '<span class="floating-cart-count" id="floating-cart-count">0 items</span>' +
            '<span class="floating-cart-total" id="floating-cart-total"></span>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="floating-cart-btn" id="floating-cart-open-drawer" aria-label="View Cart">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"></path></svg>' +
        '</button>' +
      '</div>';

    document.body.appendChild(bar);

    thumbsContainer = document.getElementById('floating-cart-thumbnails');
    countEl = document.getElementById('floating-cart-count');
    totalEl = document.getElementById('floating-cart-total');

    /* Open cart drawer on button click */
    document.getElementById('floating-cart-open-drawer').addEventListener('click', function () {
      var cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) {
        window.location.href = '/cart';
        return;
      }

      originalFetch('/cart?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newContent = doc.querySelector('.drawer__inner');
          var currentDrawer = cartDrawer.querySelector('.drawer__inner');

          if (newContent && currentDrawer) {
            currentDrawer.innerHTML = newContent.innerHTML;
          }

          var newCartDrawer = doc.querySelector('cart-drawer');
          if (newCartDrawer && newCartDrawer.classList.contains('is-empty')) {
            cartDrawer.classList.add('is-empty');
          } else {
            cartDrawer.classList.remove('is-empty');
          }

          cartDrawer.classList.add('active');
          var drawerEl = cartDrawer.querySelector('#CartDrawer');
          if (drawerEl) {
            drawerEl.classList.add('active');
            drawerEl.focus();
          }

          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }

          document.body.classList.add('overflow-hidden');
        })
        .catch(function () {
          window.location.href = '/cart';
        });
    });
  }

  /* ══════════════════════════════════════
     FORMAT MONEY (Indian Rupees)
     ══════════════════════════════════════ */
  function formatMoney(cents) {
    var amount = cents / 100;
    return '\u20B9' + amount.toLocaleString('en-IN');
  }

  /* ══════════════════════════════════════
     CART FINGERPRINT — detect real changes
     ══════════════════════════════════════ */
  function cartFingerprint(cart) {
    return cart.item_count + ':' + cart.total_price + ':' + (cart.items || []).map(function (i) {
      return i.id + '=' + i.quantity;
    }).join(',');
  }

  /* ══════════════════════════════════════
     SEARCH-OPEN DETECTION
     Hides the floating cart while a search
     drawer / predictive search / modal is open
     ══════════════════════════════════════ */
  var searchIsOpen = false;
  var lastCartHasItems = false;

  function isSearchOpen() {
    // 1. Dawn / Horizon predictive-search component is "open"
    var predictive = document.querySelector('predictive-search');
    if (predictive) {
      if (predictive.hasAttribute('open')) return true;
      if (predictive.getAttribute('aria-expanded') === 'true') return true;
      // Some themes mark the inner results as visible
      var results = predictive.querySelector('[aria-hidden]');
      if (results && results.getAttribute('aria-hidden') === 'false') return true;
    }

    // 2. <details> wrapper with a search summary, when open
    var detailsList = document.querySelectorAll('details[open]');
    for (var i = 0; i < detailsList.length; i++) {
      var d = detailsList[i];
      if (d.querySelector('predictive-search, input[type="search"], [name="q"]')) {
        return true;
      }
    }

    // 3. Search modal / drawer common class names
    if (document.querySelector(
      '.search-modal.is-open, ' +
      '.search-modal[open], ' +
      '.search-drawer.is-open, ' +
      '.search-drawer.active, ' +
      '.header__search.is-open, ' +
      '.menu-drawer__search.is-open, ' +
      'search-modal[open], ' +
      'details-modal[open] .search-modal'
    )) {
      return true;
    }

    // 4. Body-level state classes some themes set
    if (document.body.classList.contains('search-open') ||
        document.body.classList.contains('search-is-open') ||
        document.documentElement.classList.contains('search-open')) {
      return true;
    }

    // 5. Focused search input visible on screen
    var active = document.activeElement;
    if (active && (active.type === 'search' || active.name === 'q')) {
      var rect = active.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) return true;
    }

    return false;
  }

  function applyVisibility() {
    if (!bar) return;
    if (searchIsOpen || !lastCartHasItems) {
      bar.classList.remove('active');
    } else {
      bar.classList.add('active');
    }
  }

  function refreshSearchState() {
    var open = isSearchOpen();
    if (open !== searchIsOpen) {
      searchIsOpen = open;
      applyVisibility();
    }
  }

  function watchSearchState() {
    // Re-check on common triggers
    document.addEventListener('click', function () {
      // run after the theme has updated its DOM/classes
      setTimeout(refreshSearchState, 50);
      setTimeout(refreshSearchState, 350);
    }, true);

    document.addEventListener('focusin', function (e) {
      if (e.target && (e.target.type === 'search' || e.target.name === 'q')) {
        searchIsOpen = true;
        applyVisibility();
      }
    });

    document.addEventListener('focusout', function () {
      setTimeout(refreshSearchState, 100);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setTimeout(refreshSearchState, 50);
    });

    // Toggle events from <details>
    document.addEventListener('toggle', function (e) {
      if (e.target && e.target.matches && e.target.matches('details')) {
        refreshSearchState();
      }
    }, true);

    // Body / html class changes
    var bodyObserver = new MutationObserver(refreshSearchState);
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    bodyObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    // Watch attribute/class changes on predictive-search & search modals
    var targets = document.querySelectorAll(
      'predictive-search, search-modal, .search-modal, .search-drawer, .header__search, details-modal'
    );
    targets.forEach(function (t) {
      var mo = new MutationObserver(refreshSearchState);
      mo.observe(t, { attributes: true, attributeFilter: ['open', 'class', 'aria-expanded', 'aria-hidden'] });
    });
  }

  /* ══════════════════════════════════════
     UPDATE BAR WITH CART DATA
     ══════════════════════════════════════ */
  function updateBar(cart) {
    if (!bar) createBar();

    var itemCount = cart.item_count || 0;
    var fingerprint = cartFingerprint(cart);
    var changed = fingerprint !== lastCartToken;
    lastCartToken = fingerprint;

    lastCartHasItems = itemCount > 0;

    if (itemCount === 0) {
      bar.classList.remove('active');
      return;
    }

    /* Update count + total */
    countEl.textContent = itemCount + (itemCount === 1 ? ' item' : ' items');
    totalEl.textContent = formatMoney(cart.total_price);

    /* Only rebuild thumbnails if cart actually changed */
    if (changed) {
      thumbsContainer.innerHTML = '';
      var items = cart.items || [];
      var shown = Math.min(items.length, MAX_THUMBS);
      var overflow = items.length - shown;

      for (var i = 0; i < shown; i++) {
        var item = items[i];
        var imgUrl = '';
        if (item.featured_image && item.featured_image.url) {
          imgUrl = item.featured_image.url.replace(/(\.[a-z]+)(\?|$)/, '_80x$1$2');
        } else if (item.image) {
          imgUrl = item.image.replace(/(\.[a-z]+)(\?|$)/, '_80x$1$2');
        }

        var thumb = document.createElement('div');
        thumb.className = 'floating-cart-thumb';
        thumb.style.animationDelay = (i * 0.05) + 's';
        thumb.style.zIndex = 10 - i;

        if (imgUrl) {
          thumb.innerHTML = '<img src="' + imgUrl + '" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '" loading="lazy">';
        }

        thumbsContainer.appendChild(thumb);
      }

      if (overflow > 0) {
        var badge = document.createElement('div');
        badge.className = 'floating-cart-overflow';
        badge.style.animationDelay = (shown * 0.05) + 's';
        badge.style.zIndex = 10 - shown;
        badge.textContent = '+' + overflow;
        thumbsContainer.appendChild(badge);
      }

      /* Pulse only on actual change */
      bar.classList.remove('pulse');
      void bar.offsetWidth;
      bar.classList.add('pulse');
    }

    /* Respect search-open state */
    applyVisibility();
  }

  /* ══════════════════════════════════════
     FLYING PRODUCT ANIMATION
     ══════════════════════════════════════ */
  window.triggerFloatingCartAnimation = function (imageUrl, triggerElement) {
    if (!bar || !triggerElement) return;

    var fc = document.getElementById('flying-product-container');
    if (!fc) {
      fc = document.createElement('div');
      fc.className = 'flying-product-container';
      fc.id = 'flying-product-container';
      document.body.appendChild(fc);
    }

    var startRect = triggerElement.getBoundingClientRect();
    var barRect = bar.getBoundingClientRect();

    var startX = startRect.left + startRect.width / 2;
    var startY = startRect.top + startRect.height / 2;
    var endX = barRect.left + 40;
    var endY = barRect.top + barRect.height / 2;

    var flyEl = document.createElement('div');
    flyEl.className = 'flying-product';
    flyEl.innerHTML = '<img src="' + imageUrl + '" alt="">';
    flyEl.style.left = startX - 25 + 'px';
    flyEl.style.top = startY - 25 + 'px';
    flyEl.style.transition = 'all 0.6s cubic-bezier(0.2, 0.8, 0.2, 1)';
    flyEl.style.transform = 'scale(1)';
    flyEl.style.opacity = '1';

    fc.appendChild(flyEl);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        flyEl.style.left = endX - 25 + 'px';
        flyEl.style.top = endY - 25 + 'px';
        flyEl.style.transform = 'scale(0.3)';
        flyEl.style.opacity = '0.5';
      });
    });

    setTimeout(function () {
      flyEl.remove();
    }, 700);
  };

  /* ══════════════════════════════════════
     DEBOUNCED FETCH — uses originalFetch
     so it never gets intercepted
     ══════════════════════════════════════ */
  function debouncedFetchAndUpdate() {
    if (isUpdating) return;
    clearTimeout(updateTimer);
    updateTimer = setTimeout(function () {
      isUpdating = true;
      originalFetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateBar(cart);
        })
        .catch(function () {})
        .finally(function () {
          isUpdating = false;
        });
    }, 500);
  }

  /* ══════════════════════════════════════
     LISTENERS — NO MONKEY PATCHING fetch
     Safe detection via events + observer
     ══════════════════════════════════════ */

  /* 1. Listen for cart:updated custom events */
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.item_count !== undefined) {
      updateBar(e.detail);
    } else {
      debouncedFetchAndUpdate();
    }
  });

  /* 2. MutationObserver on cart icon bubble */
  function watchCartBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;

    var observer = new MutationObserver(function () {
      debouncedFetchAndUpdate();
    });

    observer.observe(bubble, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  /* 3. XHR interceptor for XMLHttpRequest cart calls */
  var origXHROpen = XMLHttpRequest.prototype.open;
  var origXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function () {
    this._fcUrl = arguments[1] || '';
    return origXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var url = this._fcUrl || '';

    if (url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1) {
      this.addEventListener('load', function () {
        debouncedFetchAndUpdate();
      });
    }

    return origXHRSend.apply(this, arguments);
  };

  /* ══════════════════════════════════════
     INITIAL LOAD
     ══════════════════════════════════════ */
  function initialLoad() {
    originalFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateBar(cart);
        watchCartBubble();
        watchSearchState();
        refreshSearchState();
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialLoad);
  } else {
    initialLoad();
  }

  /* ══════════════════════════════════════
     BACK/FORWARD CACHE
     ══════════════════════════════════════ */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      lastCartToken = '';
      initialLoad();
    }
  });

  /* ══════════════════════════════════════
     GLOBAL API
     ══════════════════════════════════════ */
  window.updateFloatingCart = debouncedFetchAndUpdate;

})();